<template>
  <section
    class="hero-section ptb-100 gradient-overlay"
    :class="{ loaded }"
    :style="backgroundStyle"
  >
    <!-- 🌫 ЛЁГКАЯ ДЫМКА -->
    <div class="hero-overlay" />

    <div
      class="hero-bottom-shape-two"
      style="background: url('/assets/hero-bottom-shape.svg') no-repeat bottom center"
    ></div>

    <div class="container">
      <div class="row justify-center">
        <div class="col-md-10 text-white text-center">
          <h1 class="text-white mb-2">
            {{ title }}
          </h1>

          <!-- Breadcrumbs top -->
          <div v-if="breadcrumbsTop?.length" class="custom-breadcrumb mt-3">
            <ol class="breadcrumb bg-transparent d-inline-block py-0">
              <li
                v-for="(crumb, index) in breadcrumbsTop"
                :key="index"
                class="breadcrumb-item d-inline-block text-white"
              >
                <a
                  v-if="crumb.link"
                  :href="crumb.link"
                  class="text-white"
                >
                  {{ crumb.label }}
                </a>
                <span v-else>
                  {{ crumb.label }}
                </span>
              </li>
            </ol>
          </div>

          <!-- Breadcrumbs bottom -->
          <div
            v-if="breadcrumbsBottom?.length"
            class="custom-breadcrumb mt-2"
          >
            <ol class="breadcrumb bg-transparent d-inline-block py-0">
              <li
                v-for="(crumb, index) in breadcrumbsBottom"
                :key="index"
                class="breadcrumb-item d-inline-block text-white"
              >
                {{ crumb.label }}
              </li>
            </ol>
          </div>

          <slot name="actions" />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  title: { type: String, required: true },
  backgroundImageUrl: { type: String, default: '' },
  breadcrumbsTop: { type: Array, default: () => [] },
  breadcrumbsBottom: { type: Array, default: () => [] },
  loaded: { type: Boolean, default: false }
})

/**
 * ⚠️ фон есть всегда
 * пока loaded=false → используем дефолт
 * потом плавно заменяем
 */
const backgroundStyle = computed(() => {
  const url = props.loaded && props.backgroundImageUrl
    ? props.backgroundImageUrl
    : '/assets/header-bg-5.jpg' // базовый фон

  return {
    backgroundImage: `url('${url}')`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'top center',
    backgroundSize: 'cover'
  }
})
</script>

<style scoped>
/* ===== HERO ===== */
.hero-section {
  position: relative;
  color: #fff;
  overflow: hidden;
  transition: background-image 0.8s ease;
}

/* затемнение */
.hero-section::before {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 0;
}

/* ===== ЛЁГКАЯ ДЫМКА ===== */
.hero-overlay {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;

  backdrop-filter: blur(6px);
  background: rgba(255, 255, 255, 0.06);

  opacity: 1;
  transition:
    opacity 0.8s ease,
    backdrop-filter 0.8s ease;
}

/* после загрузки баннера */
.hero-section.loaded .hero-overlay {
  opacity: 0;
  backdrop-filter: blur(0px);
}

/* ===== контент ===== */
.hero-section .container {
  position: relative;
  z-index: 2;
}

/* ===== breadcrumbs ===== */
.custom-breadcrumb .breadcrumb {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 0;
  margin: 0;
  background: transparent;
}

/* ===== typography ===== */
h1 {
  font-size: 2rem;
}

@media (max-width: 768px) {
  h1 {
    font-size: 1.4rem;
  }
}
</style>
